export enum ThumbsFeedbackType {
  THUMBS_UP = "thumbs_up",
  THUMBS_DOWN = "thumbs_down",
}
